import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EcomNetworkUtils } from "../ecom-base-entities/ecom-shared/ecom-networkutils.service";
import { MMOutput } from "../ecom-models/response-model";
import { EComService } from "../ecom-services/ecom-common.service";

@Injectable()

export class GiftcardService {

    constructor(public ecomservice: EComService) { }

    // Cache giftcard availability per company so it is only fetched once per
    // app session. Survives navigation (singleton service) but is cleared on
    // a full page refresh when the app reboots.
    private giftcardAvailabilityCache = new Map<string, boolean>();

    async hasGiftcards(companyId: string): Promise<boolean> {
        if (this.giftcardAvailabilityCache.has(companyId)) {
            return this.giftcardAvailabilityCache.get(companyId) === true;
        }
        const res = await this.fetchGiftcards({ companyId }).toPromise();
        const available = !!(res && res.isSuccess && res.listValue && res.listValue.giftcards && res.listValue.giftcards.length > 0);
        this.giftcardAvailabilityCache.set(companyId, available);
        return available;
    }

    fetchGiftcards(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_GET_ALL}`, model, '', true);
    }

    createGiftcardPayment(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_MAKE_PAYMENT}`, model, '', true);
    }

    fetchPurchasesGiftcard(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_GET_PURCHASED_GIFTCARD}`, model, '', true);
    }

    checkGiftcardStatus(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_GET_GIFTCARD_STATUS}`, model, '', true);
    }

    closePreviousDayOpenedFloat(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_CLOSE_PREVIOUS_DAY_OPENED_FLOAT}`, model, '', true
        );
    }

    checkOpenFloatShift(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_CHECK_OPEN_FLOAT_SHIFT}`, model, '', true);
    }

    saveOpenFloatShift(model): Observable<MMOutput> {
        return this.ecomservice.httpPost(`${EcomNetworkUtils.GIFTCARD_SAVE_OPEN_FLOAT_SHIFT}`, model, '', true);
    }

}

export const FPX_STAGING = [
    { value: 'FPXD_ABB0233', text: 'Affin Bank Berhad', selected: false },
    { value: 'FPXD_ABB0234', text: 'Affin Bank Berhad B2C - Test ID', selected: false },
    { value: 'FPXD_ABMB0212', text: 'Alliance Bank Malaysia Berhad', selected: false },
    { value: 'FPXD_AGRO01', text: 'BANK PERTANIAN MALAYSIA BERHAD (AGROBANK)', selected: false },
    { value: 'FPXD_AMBB0209', text: 'AmBank Malaysia Berhad', selected: false },
    { value: 'FPXD_BCBB0235', text: 'CIMB Bank Berhad', selected: false },
    { value: 'FPXD_BIMB0340', text: 'Bank Islam Malaysia Berhad', selected: false },
    { value: 'FPXD_BKRM0602', text: 'Bank Kerjasama Rakyat Malaysia Berhad', selected: false },
    { value: 'FPXD_BMMB0341', text: 'Bank Muamalat Malaysia Berhad', selected: false },
    { value: 'FXPD_BSN0601', text: 'Bank Simpanan Nasional', selected: false },
    { value: 'FXPD_BOCM01', text: 'Bank Of China (M) Berhad', selected: false },
    { value: 'FXPD_CIT0219', text: 'CITI Bank Berhad', selected: false },
    { value: 'FPXD_HLB0224', text: 'Hong Leong Bank Berhad', selected: false },
    { value: 'FPXD_HSBC0223', text: 'HSBC Bank Malaysia Berhad', selected: false },
    { value: 'FPXD_KFH0346', text: 'Kuwait Finance House (Malaysia) Berhad', selected: false },
    { value: 'FPXD_MBB0228', text: 'Malayan Banking Berhad (M2E)', selected: false },
    { value: 'FPXD_MB2U0227', text: 'Malayan Banking Berhad (M2U)', selected: false },
    { value: 'FPXD_OCBC0229', text: 'OCBC Bank Malaysia Berhad', selected: false },
    { value: 'FPXD_PBB0233', text: 'Public Bank Berhad', selected: false },
    { value: 'FPXD_RHB0218', text: 'RHB Bank Berhad', selected: false },
    { value: 'BOCM01', text: 'Bank Of China (M) Berhad' },
    //{ value: 'FPXD_TEST0021', text: 'SBI BANK A' }, //GHL bank code
    { value: 'TEST0021', text: 'SBI BANK A', selected: false }, // RH Bank code and rest in the list are GHL staging codes
    { value: 'FPXD_TEST0022', text: 'SBI BANK B', selected: false },
    { value: 'FPXD_TEST0023', text: 'SBI BANK C', selected: false },
    { value: 'FPXD_SCB0216', text: 'Standard Chartered Bank', selected: false },
    { value: 'FPXD_UOB0226', text: 'United Overseas Bank', selected: false },
    { value: 'FPXD_UOB0229', text: 'United Overseas Bank - B2C Test', selected: false },
    { value: 'FPXD_UOB0229', text: 'United Overseas Bank - B2C Test', selected: false }
];

export const FPX_PRODUCTION = [
    { value: 'ABB0233', text: 'Affin Bank Berhad', selected: false },
    { value: 'ABMB0212', text: 'Alliance Bank Malaysia Berhad', selected: false },
    { value: 'AGRO01', text: 'BANK PERTANIAN MALAYSIA BERHAD (AGROBANK)', selected: false },
    { value: 'AMBB0209', text: 'AmBank Malaysia Berhad', selected: false },
    { value: 'BIMB0340', text: 'Bank Islam Malaysia Berhad', selected: false },
    { value: 'BMMB0341', text: 'Bank Muamalat Malaysia Berhad', selected: false },
    { value: 'BKRM0602', text: 'Bank Kerjasama Rakyat Malaysia Berhad', selected: false },
    { value: 'BSN0601', text: 'Bank Simpanan Nasional', selected: false },
    { value: 'BCBB0235', text: 'CIMB Bank Berhad', selected: false },
    { value: 'BOCM01', text: 'Bank Of China (M) Berhad' },
    { value: 'HLB0224', text: 'Hong Leong Bank Berhad', selected: false },
    { value: 'HSBC0223', text: 'HSBC Bank Malaysia Berhad', selected: false },
    { value: 'KFH0346', text: 'Kuwait Finance House (Malaysia) Berhad', selected: false },
    { value: 'MBB0228', text: 'Malayan Banking Berhad (M2E)', selected: false },
    { value: 'MB2U0227', text: 'Malayan Banking Berhad (M2U)', selected: false },
    { value: 'OCBC0229', text: 'OCBC Bank Malaysia Berhad', selected: false },
    { value: 'PBB0233', text: 'Public Bank Berhad', selected: false },
    { value: 'RHB0218', text: 'RHB Bank Berhad', selected: false },
    { value: 'SCB0216', text: 'Standard Chartered Bank', selected: false },
    { value: 'UOB0226', text: 'United Overseas Bank', selected: false }
];

export function base64decodedString(value) {
    return atob(value);
}